/**
 * @typedef {Object} activityStatus Defines activity instance status
 * @property {string} state Current state
 * @property {string} message Message
 * @property {Date} time Time of the last status update
 */
export class ActivityStatus {
  public state: string;
  public message: string;
  public time: Date;

  constructor(state: string, message: string, time: Date) {
    this.state = state;
    this.message = message;
    this.time = time;
  }

  public getState(): string {
    return this.state;
  }

  public getMessage(): string {
    return this.message;
  }

  public getTime(): Date {
    return this.time;
  }
}
